import { collection, doc } from 'firebase/firestore';
import getFirestore from '..';

function generateId() {
  const db = getFirestore();
  const { id } = doc(collection(db, 'applets'));
  return id;
}
export default generateId;
